<template>
	<div
		:class="[
			'pdp-attribute',
			{
				'selected': attribute.isSelected,
				'disabled': attribute.unavailable,
				'has-swatch': attribute.swatchUrl != null
			}
		]"
	>
		<label
			class="display"
			:class="{
				'pdp-attribute-swatch': !!attribute.swatchUrl,
				'pdp-attribute-no-swatch flex flex-center-all': !attribute.swatchUrl,
			}"
		>
			<input
				type="radio"
				role="radio"
				:name="attribute.selector.replace(/\s/g, '')"
				:checked="attribute.isSelected"
				:aria-disabled="attribute.unavailable != null ? attribute.unavailable.toString() : false"
				@change="$emit('change')"
			/>

			<template v-if="!attribute.swatchUrl">
				{{ attribute.value }}
			</template>
			<div v-else class="pdp-attribute-swatch-image" :style="backgroundImgStyle">
				<span class="visually-hidden">{{ attribute.value }}</span>
			</div>
			<span v-if="attribute.unavailable" class="visually-hidden">(unavailable)</span>
		</label>
		<div v-if="attribute.unavailable" class="pdp-att-x flex flex-center-all">
			<img src="/assets/images/icons/x.svg" height="15" width="15" alt="" />
		</div>
	</div>
</template>

<script>
import { checkWebpSupport } from '../../helpers/functions.js';

export default {
	name: "ChildSelectorAttribute",
	data: function () {
		return {
			swatchUrl: null,
		};
	},
	props: {
		attribute: {
			type: Object,
			required: true,
		},
	},
	computed: {
		selected() {
			return this.$store.state.selectedAttributes;
		},
		remainingVariants() {
			return this.$store.getters.remainingVariants;
		},
		backgroundImgStyle() {
			if (this.swatchUrl) {
				return `background-image:url('${this.swatchUrl}')`;
			} else {
				return "";
			}
		},
	},
	mounted() {
		const self = this;
		checkWebpSupport(function(isSupported) {
			if (isSupported) {
				self.swatchUrl = self.attribute.swatchUrlWebp;
			} else {
				self.swatchUrl = self.attribute.swatchUrl;
			}
		});
	},
};
</script>

<style lang="less">
@import '../../../less/_mixins.less';
.pdp-attribute {
	border: solid 2px #FFF;
	cursor: pointer;
	display: inline-block;
	margin-right: 10px;
	margin-top: 10px;
	position: relative;
	left: -2px;
	.mobile-styles({
		font-size: 14px;
	});


	.pdp-attribute-swatch {
		display: block;
		border: solid 2px #DDD;
		padding: 0;
	}

	.pdp-attribute-swatch-image {
		background-position: center center;
		background-size: cover;
		height: 35px;
		width: 35px;
	}

	.pdp-attribute-no-swatch {
		display: block;
		background-image: none !important;
		background-color: #F5F5F5 !important;
		border: 1px solid #AFAFAF !important;
		border-radius: 0 !important;
		font-weight: bold;
		color: @blue-main;
		padding: 10px 9px !important;
		font-size: 16px !important;
		min-width: 35px;
		text-align: center;
		position: relative !important;

	}

	&.selected {
		border: solid 2px #000000;
	}

	label {
		cursor: pointer;
	}

	label:focus-within {
		.focus-outline()
	}

	&.disabled {
		position: relative;
		.pdp-attribute-swatch {
			> div {
				opacity: 0.4;
			}
		}

		.pdp-attribute-no-swatch {
			opacity: 0.5;
		}

		.pdp-att-x {
			font-size: 22px;
			opacity: 0.8;
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			margin: 0;
			border: none;
			padding: 0;
			background: none;
			width: 100%;
			height: 100%;
		}
	}
}
</style>